import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '@/shared/constants/linksApi.js'

// Данные для Basic Auth
const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'
const basicAuth = 'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

export const productCatalogApi = createApi({
    reducerPath: 'productCatalogApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers) => {
            headers.set('Authorization', basicAuth)
            headers.set('Content-Type', 'application/json')
            return headers
        },
    }),
    endpoints: (builder) => ({
        getAllProducts: builder.mutation({
            query: (configRequest = '') => ({
                url: '/back/product/list',
                method: 'POST',
                body: configRequest,
            }),
        }),
        getCatalogFilters: builder.mutation({
            query: (categoryId) => ({
                url: '/back/category/filters',
                method: 'POST',
                body: { category_id: categoryId },
            }),
        }),
        getProductCatalog: builder.mutation({
            query: (productId) => ({
                url: '/back/product/one',
                method: 'POST',
                body: { id: productId },
            }),
        }),
        getImagesProduct: builder.mutation({
            query: (productId) => ({
                url: '/back/product/images',
                method: 'POST',
                body: { id: productId },
            }),
        }),
        getOtherProducts: builder.mutation({
            query: (productData) => ({
                url: '/back/product/recommended',
                method: 'POST',
                body: { id: productData },
            }),
        }),
        getReviewsProduct: builder.mutation({
            query: (productId) => ({
                url: '/back/product/review',
                method: 'POST',
                body: { id: productId },
            }),
        }),
        getQuestionsProduct: builder.mutation({
            query: (productId) => ({
                url: '/back/product/faq',
                method: 'POST',
                body: { id: productId },
            }),
        }),
        getBlogProduct: builder.mutation({
            query: (productId) => ({
                url: '/back/product/blog',
                method: 'POST',
                body: { id: productId },
            }),
        }),
    }),
})
